import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function getMenuItems() {
    const response = await axios.get(API_URL + '/core/menus/items?menu=ERP-NAV');
    return response.data;
}

export async function shouldRedirectToLegacyApp() {
    let menuItems = await getMenuItems();
    let shouldRedirectToLegacyApp = menuItems.reduce(function(accumulator, menuItem) {
        return accumulator && menuItem.is_legacy;
    }, true);
    return shouldRedirectToLegacyApp;
}